import React from 'react';

import { ProductHitProps } from '../../containers/hits/HitWithWishlist';
import AngleRight from '../icon/regular/AngleRight';
import HeartRegular from '../icon/regular/Heart';
import HeartSolid from '../icon/solid/Heart';

export default function PerfectFitProduct({
  title,
  url,
  image,
  salePriceFormatted,
  isInWishlist,
  onWishlistClick,
}: ProductHitProps) {
  return (
    <div className="group/card-product relative text-gray-950 w-1/3">
      <div className="relative mb-4">
        <div className="absolute top-0 left-0 w-full p-3 lg:p-6 flex justify-between gap-2">
          <button
            className={`${isInWishlist ? 'active ' : ''}group/btn-favorite transition relative flex items-center justify-center ms-auto w-7.5 h-7.5 bg-white/20 group-has-[a:hover]/card-product:bg-white [.active]:bg-white hover:bg-white rounded-sm text-white group-has-[a:hover]/card-product:text-gray-950 hover:text-gray-950 cursor-pointer z-10`}
            type="button"
            onClick={onWishlistClick}
          >
            <span className="sr-only">
              {isInWishlist
                ? Craft.t('product', 'remove from wishlist')
                : Craft.t('product', 'add to wishlist')}
            </span>
            <HeartRegular className="w-4 fill-current" />
            <HeartSolid className="absolute opacity-0 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 fill-pink-400 group-[.active]/btn-favorite:opacity-100" />
          </button>
        </div>
        {image && (
          <picture>
            <source srcSet={`${image.transforms.productCatalogImage2x.url} 2x`} />
            <img
              className="w-full h-full object-cover aspect-4/5 rounded-lg"
              src={image.transforms.productCatalogImage.url}
              alt={title}
              width={image.transforms.productCatalogImage.width}
              height={image.transforms.productCatalogImage.height}
            />
          </picture>
        )}
        <span className="absolute bottom-3 lg:bottom-6 right-3 lg:right-6 opacity-0 group-hover/card-product:opacity-100 rounded-sm w-0 group-hover/card-product:w-11 lg:group-hover/card-product:w-14 h-0 group-hover/card-product:h-11 lg:group-hover/card-product:h-13.5 bg-pink-400 text-white flex justify-center items-center transition-all">
          <AngleRight className="w-2.5 fill-current" />
        </span>
      </div>
      <div className="lg:px-1">
        <h3 className="text-gray-400 mb-0 lg:text-2xl xl:max-w-[63%]">
          <a className="no-underline before:absolute before:inset-0" href={url}>{title}</a>
        </h3>
        <div className="whitespace-nowrap">
          <div className="flex gap-2">
            <strong className="lg:text-2xl font-bold">{salePriceFormatted}</strong>
          </div>
        </div>
      </div>
    </div>
  );
}
